import angular from 'angular';

import {} from './od-signin.less';

module.exports = angular.module('market.component.od-signin', [
])
.component('odSignin', {
  template: require('./od-signin.jade')(),
  bindings: {
    email: '<?',
    onLogin: '&?',
  },
  controller: class {
    constructor($rootScope, Session) {
      this.Session = Session;
      this.session = $rootScope.session;
    }

    login() {
      this.pending = true;
      delete this.loginError;

      let session = new this.Session({
        human: {
          email: this.email,
          password: this.password,
          remember_me: this.remember_me
        }
      });
      session.$login().then((result) => {
        this.pending = false;
        this.redirect = (result.human && result.human.redirect_to) || '/';
        return this.session.$me();
      }).then((human) => {
        if (this.onLogin) {
          this.onLogin({ human: human, redirect: this.redirect });
        } else {
          window.location.href = this.redirect;
        }
      }).catch(() => {
        this.pending = false;
        this.loginError = true;
      });
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-signin.js
 **/